// extracted by mini-css-extract-plugin
export default {"faqSection":"Faq_faqSection__KPdaR","container":"Faq_container__FNjzQ","title":"Faq_title__XNGIf","btn_text":"Faq_btn_text__nyCa6","hidden_text":"Faq_hidden_text__pCmqR"};